import $ from "jquery";
import bdapi from "@bd-core/bd-api";
import { addFilter, addAction } from "@bd-core/bd-hooks";
import CONFIG from "@bd-core/config";

export const FrieslandCampina = () => {
  // @ts-ignore
  if (CONFIG.siteSetup !== "friesland-campina") return;

  var childTheme = {
    /*
     * TODO change this method to hook
     * addFilter('change_this', (value) => {return overidedValue });
     */
    printChart: (data) => {
      var answerCategories = data.categories;
      answerCategories = answerCategories.map((category) => {
        category.scorePercentage = (category.score / category.max_score) * 100;
        return category;
      });

      const sortedCategories = answerCategories.sort((a, b) =>
        a.index > b.index ? 1 : b.index > a.index ? -1 : 0
      );

      const getHighestCategoryScore = () => {
        return sortedCategories.reduce((prev, current) =>
          prev.scorePercentage > current.scorePercentage ? prev : current
        );
      };
      $(".gameScreen__title").append(
        getHighestCategoryScore().highest_score_message
      );
      $(".gameScreen__description").append(
        getHighestCategoryScore().highest_score_description
      );

      // const bgAvatar = sortedCategories.map((c) => c.color);

      const degree = 360;
      const degreePerItem = degree / sortedCategories.length;
      const pointLength = 5;
      const $listsEl = $(".sunflare__lists");

      // Set circled colorful bg
      // $('.avatarCircle__bg').attr('style', `background-color:${bgAvatar[Math.ceil(bgAvatar.length / 2) - 1]}; transform:rotate(-${degreePerItem / 2 + 90}deg)`)
      // for (let i = 0; i < bgAvatar.length; i++) {
      //     if (i < bgAvatar.length / 2) {
      //         let $kidSpace = $('<div>').addClass('kid-space').attr('style', `z-index:${Math.ceil(bgAvatar.length / 2) - i};transform:rotate(${(i + 1) * (360 / bgAvatar.length)}deg); background-color:${bgAvatar[i]}`)
      //         $('.kid-bottom').append($kidSpace)
      //     }
      //     else {
      //         let $kidSpace = $('<div>').addClass('kid-space').attr('style', `z-index:${i};transform:rotate(${i * (360 / bgAvatar.length)}deg); background-color:${bgAvatar[i]}`)
      //         $('.kid-top').append($kidSpace)
      //     }
      // }

      // circled lists
      for (let i = 0; i < sortedCategories.length; i++) {
        let rotate = degreePerItem * i;
        let $listItem = $("<li>")
          .addClass("sunflare__item")
          .attr("style", `transform:rotate(${rotate}deg)`)
          .append(
            $("<div>")
              .addClass("sunflare__placeholder")
              .attr(
                "style",
                `transform: translateY(-50%) rotate(${
                  -Math.abs(rotate) + 90
                }deg); color:${sortedCategories[i].color};`
              )
              .append(sortedCategories[i].name)
          );
        const roundUp = (n) => Math.ceil(n / 20) * 20;
        const scorePercentage = sortedCategories[i].scorePercentage;
        let scorePoint = roundUp(scorePercentage) / (100 / pointLength);
        let roundPoint = Math.ceil(scorePoint);
        let remainingPoint = Math.abs(roundPoint - scorePoint - 1);
        let bg = sortedCategories[i].color;
        // let scalePoint = 1.4;

        for (let j = 0; j < pointLength; j++) {
          let $point = $("<div>").addClass("sunflare__point");
          // scalePoint -= 0.2;
          if (j < roundPoint - 1)
            $point.append(
              $("<div>").attr("style", `width:100%; background-color:${bg}`)
            );
          if (j === roundPoint - 1)
            $point.append(
              $("<div>").attr(
                "style",
                `width:${remainingPoint * 100}%; background-color:${bg}`
              )
            );
          $listItem.append($point);
        }
        $listsEl.append($listItem);
      }

      $(".js-continue-url").click(function () {
        window.location.href = getHighestCategoryScore().highest_score_url;
      });
    },

    afterFetchResultCategories() {
      const params = new URLSearchParams(window.location.search);
      bdapi
        .post("public/get-avatar?gp-id=" + params.get("gp-id"))
        .then((res) => {
          const resData = res.data.data;
          $(".avatarCircle__image").attr(
            "style",
            `background-image: url(${resData.avatar})`
          );
        });
    },
  };

  addFilter("print-chart", () => {
    return childTheme.printChart;
  });

  addAction("after-fetch-result-categories", () => {
    return childTheme.afterFetchResultCategories();
  });
};
